// MS-7 — "E quando serve un preventivo": quote as a consequence of the collected work.
// Static presentational replica of the existing quote UI. No new capability, no backend.
const lines = [
  { desc: "Verniciatura ringhiera balcone", qty: "2,6 m", unit: "€ 100,00", total: "€ 260,00" },
  { desc: "Sostituzione piastrelle danneggiate", qty: "4 pz", unit: "€ 24,00", total: "€ 96,00" },
  { desc: "Stuccatura muretto lato scala", qty: "1", unit: "€ 80,00", total: "€ 80,00" },
];

export const QuoteOutcome = () => (
  <div
    data-testid="landing-quote-outcome"
    className="grid grid-cols-1 items-center gap-14 lg:grid-cols-[1.25fr_0.75fr] lg:gap-16"
  >
    <div>
      <p className="text-sm font-bold uppercase tracking-[0.2em] text-teal-600 sm:text-base">
        E quando serve un preventivo
      </p>
      <h2 className="mt-5 max-w-xl text-3xl font-extrabold leading-[1.15] tracking-tight text-neutral-950 sm:text-4xl">
        Non riparti da zero.
      </h2>
      <p className="mt-7 max-w-xl text-base leading-relaxed text-neutral-700 md:text-lg">
        Le informazioni raccolte durante il lavoro sono già lì. Quando arriva il momento del
        preventivo, parti da quello che hai già raccontato invece di ricostruire tutto a memoria.
      </p>
    </div>

    {/* Replica statica del preventivo */}
    <div
      aria-hidden="true"
      className="mx-auto w-full max-w-md rounded-2xl border border-neutral-200/80 bg-white p-4 shadow-[0_4px_18px_-8px_rgba(15,23,42,0.10)] sm:p-5 lg:mx-0 lg:ml-auto"
    >
      <div className="flex items-baseline justify-between gap-3">
        <div className="text-[15px] font-bold tracking-tight text-neutral-950">
          Preventivo — Mario Rossi
        </div>
        <span className="shrink-0 text-[11px] text-neutral-500">Via Roma 12</span>
      </div>

      <div className="mt-4 overflow-hidden rounded-lg border border-neutral-200">
        {lines.map((ln) => (
          <div
            key={ln.desc}
            className="flex items-start justify-between gap-3 border-b border-neutral-100 px-3 py-2 text-[12.5px] last:border-0"
          >
            <span className="min-w-0 text-neutral-800">{ln.desc}</span>
            <span className="shrink-0 whitespace-nowrap text-neutral-500">
              {ln.qty} · {ln.unit} · <b className="text-neutral-800">{ln.total}</b>
            </span>
          </div>
        ))}
        <div className="bg-neutral-50/60 px-3 py-2.5 text-[12.5px]">
          <div className="flex justify-between">
            <span className="text-neutral-500">Imponibile</span>
            <span className="text-neutral-800">€ 436,00</span>
          </div>
          <div className="mt-1 flex justify-between">
            <span className="text-neutral-500">IVA 22%</span>
            <span className="text-neutral-800">€ 95,92</span>
          </div>
          <div className="mt-2 flex justify-between border-t border-neutral-200 pt-2 text-[13.5px] font-bold text-neutral-950">
            <span>Totale</span>
            <span>€ 531,92</span>
          </div>
        </div>
      </div>

      <p className="mt-3 text-[11px] text-neutral-400">
        Generato dalle informazioni già raccolte sul lavoro.
      </p>
    </div>
  </div>
);
